import { render } from "./Presentacion.vue?vue&type=template&id=39f89950&scoped=true"
const script = {}

import "./Presentacion.vue?vue&type=style&index=0&id=39f89950&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f89950"]])

export default __exports__